export default __webpack_public_path__ + "static/media/home1.99359664.webp";